export const FEE_CONFIG_URL =
  "https://raw.githubusercontent.com/rarible/sdk/master/packages/ethereum/sdk/src/config/fees.json"

export const UNION_API_MAINNET = "https://api.rarible.org"
export const UNION_API_TESTNET = "https://testnet-api.rarible.org"
